import { RootState } from '../rootReducer';

// Activity selectors
export const selectActivityState = (state: RootState) => state.activity;

export const selectContactAttributeActivity = (state: RootState) =>
  state.activity.contactAttributeActivity;

export const selectActivityLoading = (state: RootState) =>
  state.activity.loading;

export const selectActivityError = (state: RootState) => state.activity.error;

export const selectActivityPagination = (state: RootState) =>
  state.activity.pagination;
